"use strict";
/**
 * @author       Yannick Deubel (https://github.com/yandeu)
 * @copyright    Copyright (c) 2020 Yannick Deubel; Project Url: https://github.com/enable3d/enable3d
 * @license      {@link https://github.com/enable3d/enable3d/blob/master/LICENSE|GNU GPLv3}
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedGroup = void 0;
const index_1 = require("@enable3d/three-wrapper/dist/index");
class ExtendedGroup extends index_1.Group {
    constructor() {
        super();
        this.isMesh = false;
        this.hasBody = false;
        this.name = `object-${this.id}`;
    }
}
exports.ExtendedGroup = ExtendedGroup;
//# sourceMappingURL=extendedGroup.js.map